import { useState, useEffect } from 'react';
import QuickFilter from '../../Common/QuickFilter';
import { getUniqueSortedLabelValuePairsFromNumbers } from '../../utils';

const CustomerQuickFilter = (props) => {
  const [equipPref, setEquipPref] = useState({
    maxEquipSizes: [],
    minEquipSizes: [],
    fixedEquipSizes: []
  });
  const [overrideRoutes, setOverrideRoutes] = useState([]);

  useEffect(() => {
    props.glEventHub.on('updatedCustomerData', updateCustomerData);
    return () => {
      props.glEventHub.off('updatedCustomerData', updateCustomerData);
    };
  }, [props.glEventHub]);

  const updateCustomerData = ({
    maxEquipSizes,
    minEquipSizes,
    fixedEquipSizes,
    overrideRoutes
  }) => {
    setEquipPref({
      maxEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(maxEquipSizes),
      minEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(minEquipSizes),
      fixedEquipSizes: getUniqueSortedLabelValuePairsFromNumbers(fixedEquipSizes)
    });
    setOverrideRoutes(getUniqueSortedLabelValuePairsFromNumbers(overrideRoutes));
  };

  return (
    <QuickFilter
      key={props.filterName}
      customStore={{
        CustomerStore: {
          overrideRoutes,
          ...equipPref
        }
      }}
      {...props}
    />
  );
};

export default CustomerQuickFilter;
